import * as React from 'react';
import { Heading, Paragraph } from 'components/src/typography';
import { Scalars } from 'types/generated';
import Image from 'next/image';
import { getOr } from '@/utils/options';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { Document, BLOCKS } from '@contentful/rich-text-types';
import clsx from 'clsx';

type Props = {
  title?: string | null;
  discription?: { json: Scalars['JSON']['output'] } | null;
  icon?: string | null;
  leftAligned: boolean;
};

const ListItem = ({ title = '', discription, icon = '', leftAligned }: Props) => {
  return (
    <div
      className={`col-span-7 row-span-2 grid grid-cols-[40px_repeat(11,1fr)] grid-rows-[40px_1fr] gap-0 gap-x-24 py-32 ${clsx(
        {
          'md:col-start-6': leftAligned,
        }
      )}`}
    >
      <div className="col-span-1 row-span-1 grid rounded-full bg-red-100">
        <Image
          src={getOr(icon, '')}
          alt={getOr(title, '')}
          width={0}
          height={0}
          sizes={'40px'}
          className={' h-1/2 w-full self-center'}
        />
      </div>
      <div className="col-span-full col-start-2 row-span-3 self-center">
        <Heading classes="pt-8" variant="xxs">
          {title}
        </Heading>
        <div>
          {discription &&
            documentToReactComponents(discription.json as Document, {
              renderNode: {
                [BLOCKS.PARAGRAPH]: (_node, children) => {
                  return (
                    <Paragraph variant="medium" classes="text-black-100">
                      {children}
                    </Paragraph>
                  );
                },
              },
            })}
        </div>
      </div>
    </div>
  );
};
export default ListItem;
